import { Component, OnInit, OnDestroy, Inject, ChangeDetectorRef, Input } from '@angular/core';
import { CalendarDateFormatter, CalendarEvent, CalendarMonthViewDay, CalendarView } from 'angular-calendar';
import { CustomDateFormatter } from './custom-date-formatter.provider';
import { CalendarService } from 'src/app/services/calendar.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from 'src/app/services/user.service';
import { CalendarTypeService } from 'src/app/services/calendar-type.service';
import { Subscription } from 'rxjs';
import { calendarColors } from 'src/app/classes/calendar';



interface CustomCalendarEvent extends CalendarEvent {
	nurIntern?: boolean; // Optionales Flag hinzufügen
  }

@Component({
	selector: 'app-event-grid',
	templateUrl: './event-grid.component.html',
	styleUrls: ['./event-grid.component.css'],
	providers: [
		{
			provide: CalendarDateFormatter,
			useClass: CustomDateFormatter,
		},
	]
})

export class EventGridComponent implements OnInit, OnDestroy {

	@Input() isInternalCalendar: boolean = false;

	viewDate = new Date();
	excludeDays = [];
	events: CustomCalendarEvent[] = [];

	view: CalendarView = CalendarView.Month;

	bAdmin = this.authenticationService.isAdmin();

	private _queryListener = (e: any) => { };
	smQuery = this.media.matchMedia('(max-width: 450px)');
	mQuery = this.media.matchMedia('(max-width: 1440px)');

	subscribedEventIds: string[] = [];
	unsubscribedEventIds: string[] = [];

	private subscription = new Subscription();



	constructor(
		private calendarService: CalendarService,
		private router: Router,
		private authenticationService: AuthenticationService,
		private media: MediaMatcher,
		private changeDetectorRef: ChangeDetectorRef,
		private userService: UserService,
		private calendarTypeService: CalendarTypeService,
	) {

		this._queryListener = () => { this.changeDetectorRef.detectChanges(); };
		this.smQuery.addEventListener('change', this._queryListener);
		this.mQuery.addEventListener('change', this._queryListener);

	}


	ngOnInit() {

		this.subscribedEventIds = this.calendarService.getSubscribedEventIds();
		this.unsubscribedEventIds = this.calendarService.getUnsubscribedEventIds();

		this.subscription.add(
			this.calendarTypeService.isInternalCalendar$.subscribe(isInternal => {
				this.isInternalCalendar = isInternal;
				this.loadEvents();
			})
		);

	}

	ngOnDestroy() {
		this.subscription.unsubscribe();

	}

	private loadEvents() {

		this.calendarService.getCalendarEvents(this.isInternalCalendar).subscribe((events: CustomCalendarEvent[]) => {

	  
		  this.events = events.map(e => {
			let title = e.title;
			if (!title || !title.length) title = "Veranstaltung ohne Titel";
			else if (title.length > 30) title = title.substring(0, 30) + "…";
	  
			// Setze die Farbe basierend auf dem "nurIntern"-Flag und "bReleased"
			e.nurIntern = e.nurIntern !== undefined ? e.nurIntern : false;

			let eventColor;
			if (!e.meta?.bReleased) {
			  // Wenn nicht freigegeben, setze die Farbe auf Grau
			  eventColor = calendarColors['grey'];
			} else if (e.meta?.nurIntern) {
			  // Wenn freigegeben und intern, setze die Farbe auf Orange
			  eventColor = calendarColors['orange'];  // Interne Veranstaltungen
			} else {
			  // Freigegebene externe Veranstaltungen in Blau
			  eventColor = calendarColors['blue'];
			}
	  
			return { 
			  ...e, 
			  title: title, 
			  color: eventColor // Weise die Farbe zu
			};
		  });

	  
		  if (this.bAdmin) {
			this.userService.loadUsernameCache().subscribe(b => {
			  if (b) {
				for (const event of this.events) {
				  event.meta['subscribedUsernames'] = this.userService.getCachedUsernames(event.meta['subscribedUserIds']);
				}
			  }
			});
		  }
		});
	  }

	beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }) {
		body.forEach((day) => {
			day.badgeTotal = 0;
		});
	}

	dayClicked(day: { date: Date }) {

		console.log("day clicked", day, day.date.getTime())

		if (!this.bAdmin) return;

		this.router.navigate(["Veranstaltungen/bearbeiten"], { queryParams: { tms: day.date.getTime() } });
	}

	eventClicked($event: Event, event: CalendarEvent) {

		console.log("eventClicked", event)

		$event.stopPropagation();	// to avoid the dayClicked event



		if (event.meta?.nurIntern) {
			this.calendarTypeService.setInternalCalendar(true);
		} else {
			this.calendarTypeService.setInternalCalendar(false);
		}

		if (this.bAdmin) {
			this.router.navigate(["Veranstaltungen/bearbeiten"], { queryParams: { id: event.id } });
		}
		else {
			this.router.navigate(["Veranstaltungen/visualisieren"], { queryParams: { id: event.id } });
		}

	}

	isThisMonth(): boolean {
		const dt = new Date();
		return (this.viewDate.getMonth() == dt.getMonth()) && (this.viewDate.getFullYear() == dt.getFullYear());
	}

	isPreviousOrNextMonth(day: CalendarMonthViewDay): boolean {
		const viewMonth = this.viewDate.getMonth();
		const viewYear = this.viewDate.getFullYear();

		const dayMonth = day.date.getMonth();
		const dayYear = day.date.getFullYear();

		return dayMonth !== viewMonth || dayYear !== viewYear;

	}

}

